import { CountryCode, countriesInfo } from './countries';

const countryCodes: CountryCode[] = Object.keys(countriesInfo) as CountryCode[];

export const isValidCountryCode = (code?: string): code is CountryCode => {
  if (!code) {
    return false;
  }

  return countryCodes.includes(code as CountryCode);
};
